import { render, staticRenderFns } from "./EmailSuccess.vue?vue&type=template&id=47d65bc2&scoped=true"
import script from "./EmailSuccess.vue?vue&type=script&lang=js"
export * from "./EmailSuccess.vue?vue&type=script&lang=js"
import style0 from "./EmailSuccess.vue?vue&type=style&index=0&id=47d65bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d65bc2",
  null
  
)

export default component.exports